import { render, staticRenderFns } from "./CollaboratorsPage.vue?vue&type=template&id=3f9b0096&scoped=true&"
import script from "./CollaboratorsPage.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsPage.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorsPage.vue?vue&type=style&index=0&id=3f9b0096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b0096",
  null
  
)

export default component.exports